module.exports = __webpack_public_path__ + "static/img/youzi.3ce715b7.png";